import { render, staticRenderFns } from "./tqip.vue?vue&type=template&id=4ef33712&"
import script from "./tqip.vue?vue&type=script&lang=js&"
export * from "./tqip.vue?vue&type=script&lang=js&"
import style0 from "./tqip.vue?vue&type=style&index=0&id=4ef33712&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports